Vue.component('download-app', {
    delimiters: ['[[', ']]'],
    template: `
        <div id="downloadModal" class="lqd-modal lity-hide">
            <div class="lqd-modal-inner">

                <div class="lqd-modal-head"></div>

                <div class="lqd-modal-content">

                    <div class="row">

                        <div class="lqd-column col-md-12 px-4 pt-45 pb-30">

                            <div class="row d-flex flex-wrap align-items-center">

                                <div class="lqd-column col-md-6 col-md-offset-1">
                                    <header class="fancy-title">
                                        <h2>Download</h2>
                                        <p v-show="!bSendingSuccess">Fill the information below and become a <span class="sq-font" style='color:black;'>SpartaQuant</span></p>
                                    </header>
                                </div>

                                <div class="lqd-column col-md-4 hidden-sm hidden-xs text-right">
                                    <div class="iconbox text-right iconbox-xl" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(216, 219, 226)","hoverColor":"rgb(0, 0, 0)"}'>
                                        <div class="iconbox-icon-wrap">
                                            <span class="iconbox-icon-container">
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                                    x="0px" y="0px" width="164px" height="164px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">
                                                    <path fill-rule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                    <path fill-rule="evenodd" d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"/>
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-show="!bSendingMail && !bSendingSuccess">
                                <div class="lqd-column col-md-10 col-md-offset-1">
                                    <div class="contact-form contact-form-inputs-underlined contact-form-button-circle">
                                        <form id="formDownload" action="#" data-url="web/backend/mailer-download.php" method="post" novalidate="novalidate">
                                            <div class="row d-flex flex-wrap">
                                                <div class="lqd-column col-md-12 mb-20">
                                                    <!-- <input class="lh-25 mb-30" type="text" v-model="firstName" name="firstName" aria-required="true" aria-invalid="false" placeholder="First Name" required> -->
                                                    <!-- <input class="lh-25 mb-30" type="text" v-model="lastName" name="lastName" aria-required="true" aria-invalid="false" placeholder="Last Name" required> -->
                                                    <input class="lh-25 mb-30" type="email" v-model="email" name="email" aria-required="true" aria-invalid="false" placeholder="Your email address" required>
                                                    <div id="download-app" data-callback="captcha_callback"></div>
                                                </div>
                                                <div v-show="error.length > 0" class="lqd-column col-md-12" style='color:red; text-align:center; margin-bottom:15px'>[[ error ]]</div>
                                                <div class="lqd-column col-md-6">
                                                    <p class="font-size-16 opacity-07"><em>You will receive an email to download the application</em></p>
                                                    <p class="font-size-16 opacity-07"><em>Only the <b style='color:#3f51b5'>Windows</b> version is available for the moment, we are still working on the Mac OS...</em></p>
                                                </div>
                                                <div class="lqd-column col-md-6 text-md-right">
                                                    <input type="submit" value="Get SpartaQuant" class="font-size-13 ltr-sp-1 font-weight-bold" @click="downloadApplication()">
                                                </div>
                                            </div>
                                        </form>
                                        <div class="contact-form-result hidden"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-show="bSendingMail && !bSendingSuccess">
                                <h3 class="text-center">Preparing the download... Please wait</h3>
                                <div class="vertical-align text-center">
                                    <div class="loader vertical-align-middle loader-dot"></div>
                                </div>
                                <br><br>
                            </div>

                            <div class="row" v-show="bSendingSuccess">
                                <div class="lqd-column col-md-10 col-md-offset-1">
                                    <div class="contact-form contact-form-inputs-underlined contact-form-button-circle">
                                        <p class="font-size-22">Check your email address, you'll receive the url to download <span class="sq-font">SpartaQuant</span></p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="lqd-modal-foot"></div>

            </div>
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
            firstName:'',
            lastName:'',
            email:'',
            captcha: '',
            error: '',
            bSendingMail: false,
            bSendingSuccess: false,
        }
    },
    mounted(){

    },
    methods: {
        downloadApplication: function(){
            this.error = "";
            var bValid = true;
            // if(this.firstName.length == 0){
            //     this.error = "Please enter a valid first name";
            //     bValid = false;
            // }
            if(this.captcha.length == 0){
                this.error = "Please confirm you are not a robot";
                bValid = false;
            }
            if(!this.validateEmail(this.email)){
                this.error = "Please enter a valid email";
                bValid = false;
            }
            if(bValid){
                grecaptcha.reset();
                this.bSendingMail = true;
                var quantDataUrl = $("#formDownload").data("url");
                var arrPostDict = {'email': this.email, 'captcha': this.captcha};
                var jsonPost = JSON.stringify(arrPostDict);
                axios.defaults.xsrfCookieName = 'csrftoken';
                axios.defaults.xsrfHeaderName = 'X-CSRFToken';
                axios
                    .post(quantDataUrl,{
                        jsonData: jsonPost,
                    })
                    .then(response => {
                        var dataRes = response.data;
                        this.bSendingMail = false;
                        if (dataRes['res'] == "1"){
                            this.bSendingSuccess =true;
                        }
                        else{
                            this.error = dataRes['msg'];
                        }
                    });
            }
        },
        validateEmail: function(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        verifyCallback: function(response){
            this.captcha = response;
        },
        closeModal: function(){
            $('[data-lity-close]').trigger('click');
        }
    },
});

function captcha_callback(response) {
    if (response.length > 1) {
        $('#resultcaptcha').text(response);
    }
}